import {
  Box,
  CircularProgress,
  Container,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  Typography,
} from "@mui/material";
import * as Yup from "yup";
import React, { useEffect, useState } from "react";
import backbluebtn from "../../../../Utils/Images/backbluebtn.png";
import CustomButton from "../../../../Components/Button/CustomButton";
import CustomInput from "../../../../Components/input/CustomInput";
import gallery from "../../../../Utils/Images/Gallery Send.png";
import { Link, useNavigate, useParams } from "react-router-dom";
import { GetSingleChallenge } from "../../../../APIs/Function/Workout/Challenges/GetSingleChallenge";
import { handleEditChallenges } from "../../../../APIs/Function/Workout/Challenges/EditChallenges";

const EditChallenge = () => {
  const validationSchema = Yup.object().shape({
    title: Yup.string().trim().required("Title is required"),
    c_type: Yup.string().trim().required("Challenge type is required"),
    r_title: Yup.string().trim().required("Reward title is required"),
    parameter: Yup.number().required("Parameter is required"),
    parameter_type: Yup.string().trim().required("Parameter type is required"),
    description: Yup.string().trim().required("Description is required"),
    image: Yup.mixed().required("Image is required"),
  });

  const [singleChallenge, setSingleChallenge] = useState({});
  const [loading, setLoading] = useState(false);
  const [loadinga, setLoadinga] = useState(false);

  const { id } = useParams();

  const handleSingleChallenge = async () => {
    try {
      setLoadinga(true);
      let res = await GetSingleChallenge(id);
      setSingleChallenge(res.r);
      setFormData({
        ...formData,
        title: res.r.title,
        c_type: res.r.c_type,
        r_title: res.r.r_title,
        parameter: res.r.parameter,
        parameter_type: res.r.parameter_type,
        description: res.r.description,
        image: res.r.image,
      });
      setLoadinga(false);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    handleSingleChallenge();
  }, []);
  console.log(singleChallenge);
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    title: "",
    c_type: "",
    r_title: "",
    parameter: "",
    parameter_type: "",
    description: "",
    image: null,
  });
  const initialFormData = {
    title: "",
    c_type: "",
    r_title: "",
    parameter: "",
    parameter_type: "",
    description: "",
    image: null,
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData({
      ...formData,
      [name]: value,
    });
    console.log(formData);
  };

  const handleImageChange = (event) => {
    const image = event.target.files[0];
    setFormData({
      ...formData,
      image: image,
    });
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
      // Validate the form data
      await validationSchema.validate(formData, { abortEarly: false });

      // If validation is successful, make the API request
      setLoading(true);
      let res = await handleEditChallenges(formData, id);
      setLoading(false);

      if (res.s) {
        alert("Data Edited Successfully");
        navigate("/weeklychallanges");
        setFormData(initialFormData);
      } else {
        console.log("API request was not successful:", res.error); // Handle API request errors here
      }
    } catch (error) {
      if (error instanceof Yup.ValidationError) {
        // Handle Yup validation errors
        const validationErrors = error.inner.map((e) => e.message);
        alert(validationErrors.join("\n"));
      } else {
        console.log("An unexpected error occurred:", error);
      }
    }
  };

  return (
    <>
      {loadinga ? (
        <Box sx={{ mt: "25%" }}>
          <CircularProgress></CircularProgress>
        </Box>
      ) : (
        <Box>
          {/* header */}
          <Box
            sx={{
              bgcolor: "#31AEF4",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              height: { xs: "50px", md: "70px", lg: "70px" },
              p: "10px",
              boxSizing: "border-box",
            }}
          >
            <Link to={"/weeklychallanges"}>
              <Box
                sx={{
                  height: { xs: "50px", md: "60px", lg: "60px" },
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <img height={"100%"} src={backbluebtn} alt="back" />
              </Box>
            </Link>
            <Box>
              <Typography
                sx={{
                  fontFamily: "Open Sans",
                  fontSize: { md: "30px", sm: "20px" },
                  fontWeight: 600,
                  lineHeight: "36px",
                  color: "#FFFFFF",
                }}
              >
                Edit Details
              </Typography>
            </Box>
            <Box>
              <CustomButton
                onClick={handleSubmit}
                sx={{
                  width: { xs: "40px", md: "50px", lg: "80px" },
                  height: { xs: "10px", md: "50px", lg: "50px " },
                }}
              >
                {loading ? <CircularProgress></CircularProgress> : "Save"}
              </CustomButton>
            </Box>
          </Box>
          {/* form */}
          <Container maxWidth="sm" sx={{ mt: "30px" }}>
            <form>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <CustomInput
                    label="Title"
                    name="title"
                    value={formData.title}
                    onChange={handleInputChange}
                    fullWidth
                    required
                  />
                </Grid>
                <Grid item xs={12}>
                  <FormControl fullWidth required>
                    <InputLabel
                      sx={{
                        backgroundColor: "#FFF",
                      }}
                    >
                      Challenges Types
                    </InputLabel>
                    <Select
                      name="c_type"
                      value={formData.c_type}
                      onChange={handleInputChange}
                      sx={{ textAlign: "left", border: "0.5px solid #ebebeb" }}
                    >
                      <MenuItem value="1">Walking</MenuItem>
                      <MenuItem value="2">Cycling</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12}>
                  <CustomInput
                    label="Reward Title"
                    name="r_title"
                    value={formData.r_title}
                    onChange={handleInputChange}
                    fullWidth
                    required
                  />
                </Grid>
                <Grid item xs={6}>
                  <CustomInput
                    label="Parameter"
                    name="parameter"
                    value={formData.parameter}
                    onChange={handleInputChange}
                    fullWidth
                    rows={4}
                    required
                  />
                </Grid>
                <Grid item xs={6}>
                  <FormControl fullWidth required>
                    <Select
                      name="parameter_type"
                      value={formData.parameter_type}
                      onChange={handleInputChange}
                      sx={{ textAlign: "left" }}
                    >
                      <MenuItem value="1">Km</MenuItem>
                      <MenuItem value="2">Min</MenuItem>
                      <MenuItem value="3">Hour</MenuItem>
                      <MenuItem value="4">Steps</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12}>
                  <CustomInput
                    label="Description"
                    name="description"
                    value={formData.description}
                    onChange={handleInputChange}
                    fullWidth
                    multiline
                    rows={4}
                    required
                  />
                </Grid>

                <Grid item xs={12}>
                  <label htmlFor="file-image-input">
                    <Box
                      sx={{
                        width: "100%",
                        bgcolor: "#F4F4F4",
                        p: "20px",
                        boxSizing: "border-box",
                        display: "flex",
                        alignItems: "center",
                        textAlign: "center ",
                        justifyContent: "center",
                        flexDirection: "column",
                      }}
                    >
                      <Box sx={{ width: "150px", height: "150px" }}>
                        <img
                          width={"100%"}
                          height={"100%"}
                          src={`https://api-qhealth.equitysofttechnologies.com/upload/images/${singleChallenge.image}`}
                          alt=""
                        />
                      </Box>
                      <Box>
                        <img src={gallery} alt="" />
                      </Box>
                      <Typography sx={{}}>Upload Image</Typography>
                    </Box>
                  </label>
                  <input
                    accept="image/*"
                    type="file"
                    id="file-image-input"
                    onChange={handleImageChange}
                    style={{ display: "none" }}
                  />
                </Grid>
              </Grid>
            </form>
          </Container>
        </Box>
      )}
    </>
  );
};

export default EditChallenge;
